import { connect } from 'react-redux'
import React, { useEffect, useState } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { Btn, CustomDropdown, ImportExcelFile } from '../../../../components'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { errorHandler } from '../../../../services/util/error.service'
import { importarPlacasPrevistaParaAssociar } from '../../../../services/api/https/deliveries/roteirizacao-previa.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
}

const INITIAL_STATE = {
  acaoSelecionada: '',
  planilhaSelecionado: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function AssociarPlacaPrevista({
  dispatch,
  history,
  acaoSelecionada,
  entregas,
  roteirizacao,
  onUpdateComplete,
}) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    setState(prevState => ({ ...prevState, acaoSelecionada: acaoSelecionada }))
  }, [acaoSelecionada])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({ ...prevState, errorMessage: null }))
    }
  }, [state.errorMessage])

  const onExportarModeloClicked = typeOfSheet => {
    try {
      if (!typeOfSheet)
        setState(prevState => ({
          ...prevState,
          errorMessage: 'Selecione um tipo de planilha para exportar',
        }))
      else if (typeOfSheet.value === 1) {
        let columns = [
          [
            'Id da Rota',
            'Shipment',
            'CD/TP',
            'CNPJ',
            'Placa T2',
            'Codigo SAP',
            'Numero do Pedido',
            'Nota Fiscal',
            'Cliente',
            'Endereço',
            'Bairro',
            'Cidade',
            'Estado',
            'Tipo de Pedido',
            'Codigo Rota SAP',
            'Peso',
            'Pallets',
            'Sequência',
            'Janela de Entrega',
            'Agenda',
            'Comentario',
            'BU / Cliente Colog',
            'Data de Coleta',
            'Data de Entrega',
            'KM',
            'Placa Primeira Perna',
            'Canal',
            'Plan Region',
            'Rede',
            'Transportadora',
            'Motivo da Reentrega',
            'Comentario Pedido',
          ],
        ]

        const nome_arquivo = 'ModeloNovoDanone.xlsx'
        gerarArquivoExcel('modeloDanone', columns, nome_arquivo)
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onFileImported = async (fileContent, typeOfSheet, identifiersFromThisRoteirizacao) => {
    if (typeOfSheet) {
      try {
        dispatch(showLoadingBox('Aguarde...', 'Associando placas com entregas'))
        await importarPlacasPrevistaParaAssociar(
          typeOfSheet.value,
          {
            fileContent: fileContent,
            identifiersFromThisRoteirizacao: identifiersFromThisRoteirizacao,
          },
          roteirizacao.id,
        )
          .then(updatedEntregas => {
            onUpdateComplete(updatedEntregas)
            dispatch(hideLoadingBox())
            dispatch(showMessageBox('Dados associados com sucesso', null))
          })
          .catch(err => {
            throw Error(err)
          })
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      }
    } else {
      dispatch(showMessageBox(null, 'É necessario selecionar um tipo de planilha.'))
    }
  }

  return (
    <div
      className="p-grid p-col-8"
      style={{
        display: state.acaoSelecionada.value !== '003' ? 'none' : 'block',
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <div className="p-grid p-align-center p-col-12" style={{ paddingBottom: 0 }}>
        <div className="p-col-6" style={{ paddingTop: 13, paddingBottom: 0 }}>
          <CustomDropdown
            showLabel={true}
            label="Planilhas de Associação"
            marginTop={0}
            optionLabel="label"
            options={[{ label: '001 - Modelo Danone - Novo', value: 1 }]}
            value={state.planilhaSelecionado}
            onChange={planilhaSelecionado =>
              setState(prevState => ({ ...prevState, planilhaSelecionado: planilhaSelecionado }))
            }
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 30, paddingBottom: 0 }}>
          <ImportExcelFile
            abaName={null}
            label="Importar"
            classes="btnImportar"
            onFileImported={fileContent =>
              onFileImported(
                fileContent,
                state.planilhaSelecionado,
                entregas.filter(e => e.selected).map(e => e.identifier),
                roteirizacao.id,
              )
            }
          />
          <div style={{ display: 'inline-block', marginLeft: 15 }}>
            <Btn onClick={() => onExportarModeloClicked(state.planilhaSelecionado)}>
              Baixar Modelo
            </Btn>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(AssociarPlacaPrevista)
